import { useState, useEffect, useMemo } from 'react';
import { useWindow } from './useWindow';
const screenSizes = {
    default: { from: 0, to: 639 },
    md: { from: 639, to: 640 },
    lg: { from: 641, to: 976 },
    xl: { from: 977, to: 1279 },
    ['2xl']: { from: 1280, to: 9999 } // 2xl
};
const comparisonOperators = {
    eq: (a, b) => a === b,
    ne: (a, b) => a !== b,
    gt: (a, b) => a > b,
    lt: (a, b) => a < b,
    ge: (a, b) => a >= b,
    le: (a, b) => a <= b
};
const getScreenSize = (myWindow) => {
    var _a;
    if (myWindow)
        return (_a = Object.entries(screenSizes).find(([, range]) => myWindow.innerWidth >= range.from && myWindow.innerWidth < range.to)) === null || _a === void 0 ? void 0 : _a[0];
};
const useScreenSize = () => {
    const myWindow = useWindow();
    const [screenSize, setScreenSize] = useState(getScreenSize(myWindow));
    const getIndex = (size) => Object.keys(screenSizes).findIndex((key) => key === size);
    const screenCompare = (operator, size) => comparisonOperators[operator](getIndex(screenSize), getIndex(size));
    useEffect(() => {
        const handleResize = () => setScreenSize(getScreenSize(myWindow));
        if (!myWindow)
            return null;
        myWindow.addEventListener('resize', handleResize);
        handleResize();
        return () => myWindow.removeEventListener('resize', handleResize);
    }, [myWindow]);
    const isMobile = screenCompare('le', 'lg');
    //Breakpoints are incorrect, change it to support tablets
    const isTablet = screenCompare('le', 'md');
    const isTabletLandscape = screenCompare('le', 'xl');
    return useMemo(() => ({ isMobile, isTablet, isTabletLandscape, screenSize, getIndex, screenCompare }), [isMobile, isTablet, screenSize, getIndex, screenCompare]);
};
export default useScreenSize;
